/** zh-CN catalogue `timeline` (W3-09; English: src/render/timeline/timeline.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'timeline',
  locale: 'zh-CN',
  messages: {
    region: '时间轴',
    columns: '时间轴列',
    gutter: '节拍标尺',
    gutterHint:
      '单击移动播放头，拖动播放头可拖拽试听（按住 {loop} 不吸附），在其他位置拖动可选择一段时间及其中的全部内容，{loop}+拖动设置循环区间',
    waveform: '波形',
    overview: '曲目总览',
    overviewHint: '单击或拖动跳转到曲目的对应位置，{loop}+拖动设置循环区间',
    loopKeyAlt: 'Alt',
    loopKeyOption: 'Option',
    loopKeyCtrlShift: 'Ctrl+Shift',
    loopKeyCmdShift: 'Cmd+Shift',
    resizeColumn: '调整列宽：{name}',
    column: '列',
  },
};

export default catalog;
